import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { PropertiesService } from "@app/core/services/properties.service";

@Injectable()
export class WASAuthService {
  constructor(
    private properties: PropertiesService,
    private translate: TranslateService,
  ) {}

  getWASAuthUrl(): string {
    try {
      const baseWasUrl = this.properties.get("wasAuthUrl");

      if (!baseWasUrl || typeof baseWasUrl !== "string") {
        console.error(
          "Property wasAuthUrl not loaded. Cannot get WAS auth URL.",
        );
        return window.location.origin;
      }

      const redirectUrl = `${window.location.origin}/`;
      const fullUrl = `${baseWasUrl}&redirectUrl=${encodeURIComponent(
        redirectUrl,
      )}`;

      return fullUrl;
    } catch (error) {
      console.error("Error getting WAS auth URL:", error);
      return window.location.origin;
    }
  }

  redirectToWASLogout(): void {
    try {
      const wasAuthUrl = this.properties.get("wasAuthUrl");

      if (!wasAuthUrl || typeof wasAuthUrl !== "string") {
        console.error(
          "Property wasAuthUrl not loaded. Cannot redirect to WAS logout.",
        );
        window.location.href = window.location.origin;
        return;
      }

      const url = new URL(wasAuthUrl);
      const redirectUrl = window.location.origin;
      const logoutUrl = `${url.origin}/${this.getCurrentLanguage()}/logout${
        url.search
      }&redirectUrl=${encodeURIComponent(redirectUrl)}`;

      window.location.href = logoutUrl;
    } catch (error) {
      console.error("Error redirecting to WAS logout:", error);
      window.location.href = window.location.origin;
    }
  }

  private getCurrentLanguage(): string {
    const languageCode =
      this.translate.currentLang ||
      this.translate.defaultLang ||
      document.documentElement.lang ||
      "en";

    return languageCode.split("-")[0].toLowerCase();
  }
}
